import { render, staticRenderFns } from "./UploadSession.vue?vue&type=template&id=54565d5e&"
import script from "./UploadSession.vue?vue&type=script&lang=js&"
export * from "./UploadSession.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports